export const DISPLAY_VERSIONS = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export const ACCESSIBLE_ELEMENTS_QUERY = 'button, [href], input, CountriesSelect, textarea';
